module.exports = __webpack_public_path__ + "static/media/accounting.87592bfe.svg";